module.exports = __webpack_public_path__ + "img/MastercardDebit.577db0c2.png";